import Vue from 'vue'
import Router from 'vue-router'
// 定义路由组件
// import footer from'@/components/footer'
import home from '@/page/home'
import historycard from '@/page/historycard'
import lifehistory from '@/page/lifehistory'
import lifepay from "@/page/lifepay"
import rehistory from "@/page/rehistory"
import customer from "@/page/customer"
import mine from "@/page/mine"
import login from "@/page/login"
import hongbao from "@/page/hongbao"
import wallet from "@/page/wallet"
import proposal from "@/page/proposal"
import phoneset from "@/page/phoneset"
import multiRecharge from "@/page/multiRecharge"
import choice from "@/page/choice"
import goods from "@/page/goods"
import integral from "@/page/integral"
import coupons from "@/page/coupons"
import rule from "@/page/rule"
import placeOrder from "@/page/placeOrder"
import complaintRecords from "@/page/complaintRecords"
import myEsim from "@/page/myEsim"

Vue.use(Router)

export default new Router({
  mode: 'hash',
  //base:'h5',
  routes: [{
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/multiRecharge',
      name: 'multiRecharge',
      component: multiRecharge
    },
    {
      path: '/choice',
      name: 'choice',
      component: choice
    },
    {
      path: '/historycard',
      name: 'historycard',
      component: historycard
    },
    {
      path: '/childOrders',
      name: 'childOrders',
      component: () => import('@/page/childOrders')
    },
    {
      path: '/lifehistory',
      name: 'lifehistory',
      component: lifehistory
    },
    {
      path: '/rehistory',
      name: 'rehistory',
      component: rehistory
    },
    {
      path: '/lifepay',
      name: 'lifepay',
      component: lifepay
    },
    {
      path: '/customer',
      name: 'customer',
      component: customer
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/hongbao',
      name: 'hongbao',
      component: hongbao,
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
    },
    {
      path: '/proposal',
      name: 'proposal',
      component: proposal,
    },
    {
      path: '/phoneset',
      name: 'phoneset',
      component: phoneset,
    },
    {
      path: '/goods',
      name: 'goods',
      component: goods,
    },
    {
      path: '/integral',
      name: 'integral',
      component: integral,
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: coupons,
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/placeOrder',
      name: 'placeOrder',
      component: placeOrder
    },
    {
      path: '/complaintRecords',
      name: 'complaintRecords',
      component: complaintRecords
    },
    {
      path: '/myEsim',
      name: 'myEsim',
      component: myEsim
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js